import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { OAuthResultComponent } from "../pages/oauth-result/oauth-result.component";
import { AutoLoginComponent } from "../pages/auto-login/auto-login.component";
import { AutoLoginMetricsComponent } from "../pages/auto-login-metrics/auto-login-metrics.component";
import { CheckLoginGuard } from "./check-login.guard";

const routes: Routes = [
  {path: '', loadChildren: () => import('../pages/home/home.module').then(m => m.HomeModule), data: {title: 'DEFAULT_PAGE_TITLE'}},
  {path: 'home', loadChildren: () => import('../pages/home/home.module').then(m => m.HomeModule), data: {title: 'DEFAULT_PAGE_TITLE'}},

  {path: 'maintenance', loadComponent: () => import('../pages/maintenance/maintenance.component').then(m => m.MaintenanceComponent)},

  {path: 'oauthresult', component: OAuthResultComponent},

  {path: 'autologin/:token', component: AutoLoginComponent},
  {path: 'autologin/metrics/:token', component: AutoLoginMetricsComponent},

  // some 3rd OAuth providers have /combi in their path, so let's redirect to the correct route here (doesn't work if redirecting to /oauthredirect.html first)
  {path: 'combi/oauthredirect.html', redirectTo: 'oauthresult'},
  // Redirect oude /combi URLs naar root
  {path: 'combi', redirectTo: ''},

  {path: 'combipackageconfig', loadChildren: () => import('../pages/authenticated/combipackageconfig/combi-package-config.module').then(m => m.CombiPackageConfigModule)},
  {path: 'combipackage', loadChildren: () => import('../pages/authenticated/combipackage/combi-package.module').then(m => m.CombiPackageModule)},

  // Rewrite Simplicate (and maybe others) deeplinks
  {path: 'combipackageinstall', redirectTo: 'combipackage'},

  {path: 'accountsettings', loadChildren: () => import('../pages/authenticated/accountsettings/accountsettings.module').then(m => m.AccountSettingsModule), canActivate: [CheckLoginGuard]},
  {path: 'dashboard', loadChildren: () => import('../pages/authenticated/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [CheckLoginGuard]},
  {path: 'login', loadChildren: () => import('../pages/login/login.module').then(m => m.LoginModule)},

  {path: 'bizcuitrequest', loadChildren: () => import('../pages/bizcuit/bizcuit.module').then(m => m.BizcuitModule)},

  {path: '404', loadComponent: () => import('../pages/not-found/not-found.component').then(m => m.NotFoundComponent)},
  {path: '**', redirectTo: '404'},
];

@NgModule({
  imports: [RouterModule.forRoot(
      routes,
      {
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
        // enableTracing: true,
        // initialNavigation: "enabled",
        // onSameUrlNavigation: "reload"
      }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
